export default __webpack_public_path__ + "static/media/sandestin.f0d0b258.png";